import type React from 'react';

import { Form, Radio, RadioGroup } from '@change/ds-forms';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { useMarketingConsentStep } from './hooks/useMarketingConsentStep';

type FormValues = {
	marketingConsent: string;
};

export const MarketingConsentStep: React.FC = () => {
	const {
		data: { marketingConsent },
		actions: { setStepData, submitStep },
	} = useMarketingConsentStep();
	const { translate } = useI18n();
	const onChange = (value: string) => {
		setStepData({ marketingConsent: value === 'yes' });
	};

	return (
		<div>
			<Form<FormValues>
				onSubmit={async () => submitStep()}
				data-testid="marketing-consent-form"
				data-qa="marketing-consent-form"
			>
				<RadioGroup
					label={translate('corgi.login_or_signup.opt_in.subtitle')}
					id="marketing-consent"
					name="marketingConsent"
					onChange={onChange}
					value={marketingConsent}
				>
					<Radio value="yes" data-testid="marketing-consent-optIn-radio" data-qa="marketing-consent-optIn-radio">
						<Translate value="corgi.login_or_signup.common.labels.true" />
					</Radio>
					<Radio value="no" data-testid="marketing-consent-optOut-radio" data-qa="marketing-consent-optOut-radio">
						<Translate value="corgi.login_or_signup.common.labels.false" />
					</Radio>
				</RadioGroup>
			</Form>
		</div>
	);
};
